import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import SnoozeIcon from "@mui/icons-material/Snooze";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useEffect, useRef, useState, useContext } from "react";
import ConfirmationDialog from "../../common/ConfirmationDialog";
import { AdminPreferencesService } from "../../services/adminPref.Service";
import { BallotDashboardService } from "../../services/ballotDashboard.Service";
import "./TeamBallotDashboard.css";
import { AppDataContext } from "../../common/appContext";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import { handleUnauthorisedError } from "../../helper";
import RouteConstants from "../../common/RouteConstants";
import { Navigate, useNavigate } from "react-router-dom";
import EmptyUI from "../../sharedComponents/emptyStateUIContainers/EmptyUI";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import HomeIcon from "@mui/icons-material/Home";
import AppConstatnts from "../../common/AppConstants";

let gridData = [];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    margin: "15px 15px 0px 15px",
    border: "1px solid lightgrey",
    boxShadow: "2px 2px 11px grey inset",
  },
  gridContainer: {
    margin: "15px",
    border: "1px solid lightgrey",
    borderRadius: "none",
    padding: theme.spacing(2),
  },
  gridTitle: {
    color: "#1d428a",
  },
  buttonArea: {
    "& button + button": {
      marginLeft: theme.spacing(2),
    },
  },
  shootingPoints: {
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0, 0, 0, 3),
    },
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(0, 0, 0, 4),
    },
  },
  borderRight: {
    position: "relative",
    paddingRight: theme.spacing(2.5),
    "&:after": {
      borderRight: "1px solid rgb(98, 122, 170)",
      content: '""',
      position: "absolute",
      right: "20px",
      width: "2px",
      height: "100%",
      top: "0",
    },
    [theme.breakpoints.down("md")]: {
      paddingRight: "0px",
      "&:after": {
        borderRight: "none",
      },
    },
  },
  actionButton: {
    textTransform: "none",
    [theme.breakpoints.up("xs")]: {
      marginTop: "10px",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("lg")]: {
      marginTop: "0px",
    },
    [theme.breakpoints.up("xl")]: {
      marginTop: "0px",
    },
  },
  statBoardHeaderTitle: {
    color: "#1d428a",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      fontWeight: "500",
      color: "#1d428a",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.5rem",
      fontWeight: "500",
      color: "#1d428a",
    },
  },
  totalVotesHeaderTitle: {
    color: "#1d428a",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
      fontWeight: "500",
      color: "#1d428a",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.5rem",
      fontWeight: "500",
      color: "#1d428a",
    },
  },
  positionsHeaderTitle: {
    color: "rgb(98,122,170)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8rem",
      fontWeight: "500",
      color: "rgb(98,122,170)",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.3rem",
      fontWeight: "500",
      color: "rgb(98,122,170)",
    },
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default function TeamBallotDashboard() {
  const classes = useStyles();
  const totalVotes = useRef(0);
  const timer = useRef(0);
  const startDateTime = useRef(null);
  const endDateTime = useRef(null);
  const isSubmitted = useRef(true);
  const [playerNameSearchText, setPlayerNameSearchText] = useState("");
  const [playerData, setPlayerData] = useState([]);
  const [totalVotesSelected, setTotalVotesSelected] = useState(0);
  const [totalVotesSubmitted, setTotalVotesSubmitted] = useState(0);
  const [positionStats, setPositionStats] = useState([0, 0, 0, 0, 0]);
  const [open, setConfirmationBoxOpen] = useState(false);
  const [voteSort, setVoteSort] = useState(0);
  const [votingDisabled, setVotingDisabled] = useState(true);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [voteMessage, setVoteMessage] = useState("Loading...");
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");
  const { user, loadContext } = useContext(AppDataContext);
  const [loading, setLoading] = useState(false);
  const [windowInnerWidth, setWindowInnerWidth] = useState(
    window.innerWidth <= 1300 ? 1460 : "auto"
  );
  const [columnMaxWidth, setColumnMaxWidth] = useState([
    "none",
    "none",
    "none",
    "none",
  ]);
  const [positionsFontStyle, setPositionsFontStyle] = useState([
    "Point Guard",
    "Shooting Guard",
    "Small Forward",
    "Power Forward",
    "Center",
  ]);
  const [openModal, setOpenModal] = useState(false);
  const [playersVotedWithoutPositions, setPlayersVotedWithoutPositions] =
    useState([]);

  const [confirmFinalVotedPlayers, setConfirmFinalVotedPlayers] = useState([]);

  //Auto audit for ballot vote data holders.
  const [autoSaveFlag, setAutoSaveFlag] = useState(false);
  const [autoSaveFlagForPosition, setAutoSaveFlagForPosition] = useState(false);
  const currentVoteId = useRef(null);

  const [ballotVoteEventId, setBallotVoteEventId] = useState(0);
  const [isTeamBallotVoteEnabled, setIsTeamBallotVoteEnabled] = useState("");

  //... Route
  const navigate = useNavigate();

  const style = {
    overflow: "hidden",
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "65vw",
    height: "80%",
    bgcolor: "background.paper",
    borderRadius: "6px",
    p: 2,
  };

  useEffect(() => {
    if (user.teamID && user.teamID > 0) {
      setLoading(true);
      try {
        //....#API-1 TO CHECK ENABLED BALLOT VOTE EVENTS.
        AdminPreferencesService.getCurrentEnabledBallotVoteEventDetails().then(
          async (response) => {
            // console.log("AdminPreferencesService", response);

            //... Currrent Enabled Ballot Vote event reponse handling.
            const filteredObject =
              response?.data?.find(
                (obj) =>
                  obj.leagueId ===
                  AppConstatnts.BALLOT_VOTE
                    .NBA_DRAFTCOMBINE_BALLOT_VOTE_EVENT_ID
              ) || {};

            if (Object.keys(filteredObject).length === 0) {
              setIsTeamBallotVoteEnabled(false);
              return;
            }

            setIsTeamBallotVoteEnabled(true);
            setBallotVoteEventId(filteredObject.eventId);

            totalVotes.current = Object.keys(filteredObject).length
              ? filteredObject.maxVoteCount
              : 0;
            if (Object.keys(filteredObject).length && filteredObject.isActive) {
              startDateTime.current = moment(
                filteredObject.votingStartDatetime
              );
              endDateTime.current = moment(filteredObject.votingEndDatetime);
              // startDateTime.current = moment("04/12/2023 20:19:44");
              // endDateTime.current = moment("04/13/2023 20:20:24");

              timer.current = setInterval(() => {
                if (
                  startDateTime.current.isAfter(
                    moment(convertTZ(new Date(), "America/New_York"))
                  )
                ) {
                  setVotingDisabled(true);
                  setVoteMessage(
                    `Voting starts ${startDateTime.current.format(
                      "MM/DD/YYYY h:mm:ss a"
                    )} onwards`
                  );
                } else if (
                  startDateTime.current.isSameOrBefore(
                    moment(convertTZ(new Date(), "America/New_York"))
                  ) &&
                  endDateTime.current.isSameOrAfter(
                    moment(convertTZ(new Date(), "America/New_York"))
                  )
                ) {
                  let milliSeconds = endDateTime.current.diff(
                    moment(convertTZ(new Date(), "America/New_York"))
                  );
                  let seconds = Math.floor(milliSeconds / 1000);
                  let minutes = Math.floor(seconds / 60);
                  let hours = Math.floor(minutes / 60);
                  let days = Math.floor(hours / 24);
                  hours = hours - days * 24;
                  minutes = minutes - days * 24 * 60 - hours * 60;
                  //console.log(`${days} days ${hours} hours ${minutes} mins`);

                  if (isSubmitted.current) {
                    setVotingDisabled(true);
                  } else {
                    setVotingDisabled(false);
                  }
                  setDays(days);
                  setHours(hours);
                  setMinutes(minutes);
                } else {
                  setVotingDisabled(true);
                  setVoteMessage(
                    `Voting ended on ${endDateTime.current.format(
                      "MM/DD/YYYY h:mm:ss a"
                    )}`
                  );
                  clearInterval(timer.current);
                }
              }, 1000);
            } else {
              setVotingDisabled(true);
              setVoteMessage("No Active Ballot Vote");
            }

            //....#API-2 TO GET BALLOT VOTE PLAYERLIST FOR ENABLED BALLOT VOTE EVENT.
            try {
              const playerList =
                await BallotDashboardService.getBallotVotePlayersList(
                  user.teamID,
                  filteredObject.eventId
                );
              //console.log("playerList", playerList);

              //... Currrent Enabled Ballot Vote event player-list reponse handling.
              let players = playerList.data;
              isSubmitted.current = false;
              players.forEach((item) => {
                item.positionStats = [0, 0, 0, 0, 0];
                item.isPlayerVoted = item.isVoted;
                item.isAlreadyVoted = item.isVoted;
                item.playerPositionID = item.positionID;
                if (item.isVoted && item.positionID > 0) {
                  item.positionStats[item.positionID - 1] = 1;
                }
                if (item.isSubmitted) {
                  isSubmitted.current = true;
                }
              });
              gridData = [...players];
              setPlayerData(players);
              setLoading(false);
              if (isSubmitted.current && votingDisabled) {
                setVotingDisabled(true);
                setVoteMessage("Ballot Vote submitted");
              } else if (
                isSubmitted.current === false &&
                votingDisabled === false
              ) {
                setVotingDisabled(false);
              }
              let currentTotalVotes = 0;
              players.forEach((elem) => {
                if (elem.isVoted) {
                  currentTotalVotes += 1;
                }
              });
              let currentSubmittedVotes = 0;
              players.forEach((elem) => {
                if (elem.isSubmitted) {
                  currentSubmittedVotes += 1;
                }
              });
              setTotalVotesSelected(currentTotalVotes);
              setTotalVotesSubmitted(currentSubmittedVotes);
              setPositionStats(() => {
                let totalSum = [0, 0, 0, 0, 0];
                players.forEach((elem) => {
                  elem.positionStats.forEach((row, i) => {
                    totalSum[i] = totalSum[i] + row;
                  });
                });
                return totalSum;
              });
            } catch (error) {
              console.error("Error getting ballot vote players list:", error);
            }
          }
        );
      } catch (error) {
        console.error(
          "Error fetching current enabled ballot vote event details:",
          error
        );
      } finally {
        setLoading(false);
      }

      window.addEventListener("resize", onResize);

      return () => {
        clearInterval(timer.current);
        window.removeEventListener("resize", onResize);
      };
    } else {
      if (Object.keys(user).length === 0) loadContext();
    }
  }, [user]);

  useEffect(() => {
    if (autoSaveFlag || autoSaveFlagForPosition) {
      if (totalVotesSelected > totalVotes.current) {
        setAlert(true);
        setAlertType("warning");
        setAlertMessage(
          "Total votes selected should not exceed max vote count"
        );

        //Undo current voted player details in case of current votes more than total expected votes.
        undoPlayerVote();
      } else {
        autoSaveDraftVotes();
      }
    }
  }, [autoSaveFlag, autoSaveFlagForPosition, totalVotesSelected]);

  const handleClose = () => {
    setOpenModal(false);
  };

  const onResize = () => {
    setWindowInnerWidth(window.innerWidth <= 1300 ? 1460 : "auto");
    setColumnMaxWidth(
      window.innerWidth <= 600
        ? ["100px", "130px", "80px", "400px"]
        : ["none", "none", "none", "none"]
    );
    setPositionsFontStyle(
      window.innerWidth <= 414
        ? ["PG", "SG", "SF", "PF", "C"]
        : [
            "Point Guard",
            "Shooting Guard",
            "Small Forward",
            "Power Forward",
            "Center",
          ]
    );
  };

  const padStart = (number) => (number > 9 ? number : `0${number}`);

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const handleConfirmationBoxClose = () => {
    setConfirmationBoxOpen(false);
    setConfirmFinalVotedPlayers([]);
  };

  const searchPlayerOrCollegeName = (searchValue) => {
    setPlayerNameSearchText(searchValue);
    if (searchValue) {
      const tempData = [...gridData];
      const updatedPlayerData = tempData.filter((elem) => {
        return (
          elem.playerName
            .toLowerCase()
            .includes(searchValue.toLowerCase().trim()) ||
          elem.collegeOrClub
            .toLowerCase()
            .includes(searchValue.toLowerCase().trim())
        );
      });
      setPlayerData(updatedPlayerData);
    } else {
      setPlayerData(gridData);
    }
  };

  const votePlayer = (e, index) => {
    const updatedPlayerData = [...playerData];
    updatedPlayerData.forEach((elem, i) => {
      if (i === index) {
        elem.isVoted = e.target.checked;
        setTotalVotesSelected(totalVotesSelected + 1);
        if (elem.isVoted === false) {
          setTotalVotesSelected(totalVotesSelected - 1);
          if (elem.positionID) {
            setTotalVotesSelected(totalVotesSelected - 1);
            elem.positionID = 0;
            elem.isAlreadyVoted = elem.isVoted;
            elem.positionStats = [0, 0, 0, 0, 0];
          }
        }
      }
    });
    setPlayerData(updatedPlayerData);
    setPositionStats(() => {
      let totalSum = [0, 0, 0, 0, 0];
      gridData.forEach((elem) => {
        elem.positionStats.forEach((row, i) => {
          totalSum[i] = totalSum[i] + row;
        });
      });
      return totalSum;
    });

    //Set falg to know that votes list has been changed and need to save the votes into audit.
    setAutoSaveFlag(true);
    currentVoteId.current = index;
  };

  const selectPlayerPosition = (e, index, playerPosition) => {
    const updatedPlayerData = [...playerData];
    updatedPlayerData.forEach((elem, i) => {
      if (i === index && elem.isVoted) {
        elem.positionID = parseInt(e.target.value);
        elem.positionStats = playerPosition;
        if (!elem.isAlreadyVoted) {
          elem.isAlreadyVoted = elem.isVoted;
          // setTotalVotesSubmitted(totalVotesSubmitted + 1);
        }
      }
    });
    setPlayerData(updatedPlayerData);
    setPositionStats(() => {
      let totalSum = [0, 0, 0, 0, 0];
      gridData.forEach((elem) => {
        elem.positionStats.forEach((row, i) => {
          totalSum[i] = totalSum[i] + row;
        });
      });
      return totalSum;
    });

    //Set falg to know that votes list has been changed and need to save the votes into audit.
    setAutoSaveFlagForPosition(true);
    currentVoteId.current = index;
  };

  const toggleVoteSort = (sortOrder) => {
    setVoteSort(sortOrder);
    gridData.sort((x, y) => {
      if (sortOrder) {
        // true values first
        return x.isVoted === y.isVoted ? 0 : x.isVoted ? -1 : 1;
      } else {
        // false values first
        return x.isVoted === y.isVoted ? 0 : x.isVoted ? 1 : -1;
      }
    });
    setPlayerData(gridData);
  };

  const validatePlayersList = () => {
    return gridData.filter((elem) => elem.isVoted && elem.positionID === 0)
      .length
      ? false
      : true;
  };

  const handleSubmitAction = (action = null) => {
    if (totalVotesSelected > totalVotes.current) {
      setConfirmationBoxOpen(false);
      setAlert(true);
      setAlertType("warning");
      setAlertMessage("Total votes selected should not exceed max vote count");
    } else {
      const isDataValid = validatePlayersList();
      if (isDataValid) {
        if (action === "final") {
          let tempData = [...gridData];
          setConfirmFinalVotedPlayers(
            tempData.filter((elem) => elem.isVoted && elem.positionID > 0)
          );
          setConfirmationBoxOpen(true);
        } else {
          submitBallotVoteList("draft");
        }
      } else {
        setConfirmationBoxOpen(false);
        let tempData = [...gridData];
        setPlayersVotedWithoutPositions(
          tempData.filter((elem) => elem.isVoted && elem.positionID === 0)
        );
        setOpenModal(true);
      }
    }
  };

  const submitBallotVoteList = (action) => {
    /* In the following code, only current latest voted players and their positions were recorded and were sent to the final
    the final submit API, which resulted in a major issue */
    // let finalFormData = gridData.filter(
    //   (elem) =>
    //     (elem.isPlayerVoted !== elem.isVoted &&
    //       elem.playerPositionID !== elem.positionID) ||
    //     elem.playerPositionID !== elem.positionID
    // );

    /* So this code is now added to resolve the above issue so that all the inital and new voted players and their positions will be considered during final submit */
    let finalFormData = gridData.filter(
      (elem) => elem.isVoted && elem.positionID > 0
    );
    finalFormData.forEach((elem) => {
      elem.userBy = user.loginID;
      elem.modifiedByName = `${user.lastName}, ${user.firstName}`;
    });

    if (action === "draft") {
      if (finalFormData.length === 0) {
        finalFormData = [
          {
            playerID: 0,
            teamID: user.teamID, //user.userTeamLeague[0].statsTeamID,
            EventId: `${ballotVoteEventId}`,
            isVoted: false,
            positionID: 0,
            isSubmitted: false,
            userBy: user.loginID,
            modifiedByName: `${user.lastName}, ${user.firstName}`,
          },
        ];
      }
      BallotDashboardService.insertBallotVotePlayersList(finalFormData)
        .then((response) => {
          setConfirmationBoxOpen(false);
          setAlert(true);
          setAlertType("success");
          setAlertMessage("Ballot Vote updated successfully");
        })
        .catch(handleUnauthorisedError);
    } else if (action === "final") {
      let formObj = [...finalFormData],
        valueSubmitted = 0;
      if (formObj.length) {
        formObj.forEach((elem) => {
          elem.isSubmitted = true;
          valueSubmitted += 1;
        });
        setTotalVotesSubmitted(valueSubmitted);
      } else {
        formObj = [
          {
            playerID: 0,
            EventId: `${ballotVoteEventId}`,
            teamID: user.teamID, //user.userTeamLeague[0].statsTeamID,
            isSubmitted: true,
            userBy: user.loginID,
          },
        ];
      }
      BallotDashboardService.insertBallotVotePlayersList(formObj)
        .then((response) => {
          setConfirmationBoxOpen(false);
          setAlert(true);
          setAlertType("success");
          setAlertMessage("Ballot Vote submitted successfully");
          isSubmitted.current = true;
          setVotingDisabled(true);
          setVoteMessage("Ballot Vote submitted");
          BallotDashboardService.submitBallotVoteConfirmationEmailToTeamUser(
            ballotVoteEventId,
            user.teamID //user.userTeamLeague[0].statsTeamID
          ).then((result) => {});
        })
        .catch(handleUnauthorisedError);
    }
  };

  //Function will undo player vote.
  const undoPlayerVote = () => {
    const updatedPlayerData = [...playerData];
    updatedPlayerData.forEach((elem, i) => {
      if (i === currentVoteId.current) {
        elem.isVoted = false;
        elem.positionID = 0;
        elem.isAlreadyVoted = elem.isVoted;
        elem.positionStats = [0, 0, 0, 0, 0];

        setTotalVotesSelected(totalVotesSelected - 1);
      }
    });

    //setTotalVotesSelected((prev) => prev - 1);
    setPlayerData(updatedPlayerData);
    clearRef();
  };

  //Function will auto save the ballot votes list.
  const autoSaveDraftVotes = () => {
    //Filter the vote list
    let finalFormData = gridData.filter(
      (elem, i) => elem.isVoted || i === currentVoteId.current
    );

    //Updating missing values.
    finalFormData.forEach((elem) => {
      elem.userBy = user.loginID;
      elem.modifiedByName = `${user.lastName}, ${user.firstName}`;
    });

    //console.log("finalFormData", finalFormData);
    //API call for storing the vote list.
    BallotDashboardService.insertBallotVotePlayersList(finalFormData)
      .then((response) => {
        clearRef();
        console.log("Auto Ballot Vote updated successfully");
      })
      .catch(handleUnauthorisedError);
  };

  const clearRef = () => {
    setAutoSaveFlag(false);
    currentVoteId.current = null;
    setAutoSaveFlagForPosition(false);
  };

  const handleNavigateToHome = () => {
    navigate(RouteConstants.HOME);
  };

  const Row = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
        // gridTemplateColumns: "300px 400px 200px 400px",
      }}
    >
      <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 300px` }}>
        <Tooltip
          title={playerData[index].playerName}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {playerData[index].playerName}
          </Typography>
        </Tooltip>
      </Box>
      <Box sx={{ maxWidth: `${columnMaxWidth[1]}`, flex: `2 0 400px` }}>
        <Tooltip
          title={playerData[index].collegeOrClub}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {playerData[index].collegeOrClub}
          </Typography>
        </Tooltip>
      </Box>
      <Box sx={{ maxWidth: `${columnMaxWidth[2]}`, flex: `1 0 200px` }}>
        <Checkbox
          sx={{ marginTop: "4px" }}
          key={index}
          color="success"
          disabled={votingDisabled}
          checked={playerData[index].isVoted}
          onChange={(e) => votePlayer(e, index)}
          inputProps={{ "aria-label": "controlled" }}
        />
      </Box>
      <Box sx={{ maxWidth: `${columnMaxWidth[3]}`, flex: `2 0 400px` }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            columnGap: "15px",
            paddingTop: "6px",
            fontWeight: "bold",
          }}
          className="radios"
        >
          <input
            type="radio"
            id={`PG-${index}`}
            name={`Group-${index}`}
            value={1}
            checked={playerData[index].positionID === 1 ? true : false}
            disabled={!playerData[index].isVoted || votingDisabled}
            onChange={(e) => {
              selectPlayerPosition(e, index, [1, 0, 0, 0, 0]);
            }}
          />
          <label className="position-label" htmlFor={`PG-${index}`} title="PG">
            1
          </label>

          <input
            type="radio"
            id={`SG-${index}`}
            name={`Group-${index}`}
            value={2}
            checked={playerData[index].positionID === 2 ? true : false}
            disabled={!playerData[index].isVoted || votingDisabled}
            onChange={(e) => {
              selectPlayerPosition(e, index, [0, 1, 0, 0, 0]);
            }}
          />
          <label className="position-label" htmlFor={`SG-${index}`} title="SG">
            2
          </label>

          <input
            type="radio"
            id={`SF-${index}`}
            name={`Group-${index}`}
            value={3}
            checked={playerData[index].positionID === 3 ? true : false}
            disabled={!playerData[index].isVoted || votingDisabled}
            onChange={(e) => {
              selectPlayerPosition(e, index, [0, 0, 1, 0, 0]);
            }}
          />
          <label className="position-label" htmlFor={`SF-${index}`} title="SF">
            3
          </label>

          <input
            type="radio"
            id={`PF-${index}`}
            name={`Group-${index}`}
            value={4}
            checked={playerData[index].positionID === 4 ? true : false}
            disabled={!playerData[index].isVoted || votingDisabled}
            onChange={(e) => {
              selectPlayerPosition(e, index, [0, 0, 0, 1, 0]);
            }}
          />
          <label className="position-label" htmlFor={`PF-${index}`} title="PF">
            4
          </label>

          <input
            type="radio"
            name={`Group-${index}`}
            value={5}
            id={`C-${index}`}
            checked={playerData[index].positionID === 5 ? true : false}
            disabled={!playerData[index].isVoted || votingDisabled}
            onChange={(e) => {
              selectPlayerPosition(e, index, [0, 0, 0, 0, 1]);
            }}
          />
          <label className="position-label" htmlFor={`C-${index}`} title="C">
            5
          </label>
        </Box>
      </Box>
    </Box>
  );

  const PlayersVotedWithoutPositionsRow = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
      }}
    >
      <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `0 0 300px` }}>
        <Tooltip
          title={playersVotedWithoutPositions[index].playerName}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {playersVotedWithoutPositions[index].playerName}
          </Typography>
        </Tooltip>
      </Box>
      <Box
        sx={{
          maxWidth: `${columnMaxWidth[1]}`,
          flex: `0 0 300px`,
        }}
      >
        <Tooltip
          title={playersVotedWithoutPositions[index].collegeOrClub}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {playersVotedWithoutPositions[index].collegeOrClub}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  );

  const VotedPlayersFinalConfirmationRow = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
      }}
    >
      <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `0 0 300px` }}>
        <Tooltip
          title={confirmFinalVotedPlayers[index].playerName}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {confirmFinalVotedPlayers[index].playerName}
          </Typography>
        </Tooltip>
      </Box>
      <Box sx={{ maxWidth: `${columnMaxWidth[1]}`, flex: `0 0 400px` }}>
        <Tooltip
          title={confirmFinalVotedPlayers[index].collegeOrClub}
          placement="bottom-start"
          enterTouchDelay={0}
        >
          <Typography
            noWrap
            component="p"
            variant={window.innerWidth < 769 ? "caption" : "body1"}
            pl={3}
            sx={{ paddingTop: "13px", fontWeight: "500" }}
          >
            {confirmFinalVotedPlayers[index].collegeOrClub}
          </Typography>
        </Tooltip>
      </Box>
      <Box sx={{ flex: `0 0 400px` }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
            columnGap: "15px",
            paddingTop: "6px",
            fontWeight: "bold",
          }}
          className="radios"
        >
          <input
            type="radio"
            id={`voted-final-players-PG-${index}`}
            name={`voted-final-players-Group-${index}`}
            value={1}
            checked={
              confirmFinalVotedPlayers[index].positionID === 1 ? true : false
            }
            disabled={true}
          />
          <label
            className="position-label"
            htmlFor={`voted-final-players-PG-${index}`}
            title="PG"
          >
            1
          </label>

          <input
            type="radio"
            id={`voted-final-players-SG-${index}`}
            name={`voted-final-players-Group-${index}`}
            value={2}
            checked={
              confirmFinalVotedPlayers[index].positionID === 2 ? true : false
            }
            disabled={true}
          />
          <label
            className="position-label"
            htmlFor={`voted-final-players-SG-${index}`}
            title="SG"
          >
            2
          </label>

          <input
            type="radio"
            id={`voted-final-players-SF-${index}`}
            name={`voted-final-players-Group-${index}`}
            value={3}
            checked={
              confirmFinalVotedPlayers[index].positionID === 3 ? true : false
            }
            disabled={true}
          />
          <label
            className="position-label"
            htmlFor={`voted-final-players-SF-${index}`}
            title="SF"
          >
            3
          </label>

          <input
            type="radio"
            id={`voted-final-players-PF-${index}`}
            name={`voted-final-players-Group-${index}`}
            value={4}
            checked={
              confirmFinalVotedPlayers[index].positionID === 4 ? true : false
            }
            disabled={true}
          />
          <label
            className="position-label"
            htmlFor={`voted-final-players-PF-${index}`}
            title="PF"
          >
            4
          </label>

          <input
            type="radio"
            name={`voted-final-players-Group-${index}`}
            value={5}
            id={`voted-final-players-C-${index}`}
            checked={
              confirmFinalVotedPlayers[index].positionID === 5 ? true : false
            }
            disabled={true}
          />
          <label
            className="position-label"
            htmlFor={`voted-final-players-C-${index}`}
            title="C"
          >
            5
          </label>
        </Box>
      </Box>
    </Box>
  );

  function convertTZ(date, tzString) {
    return new Date(
      (typeof date === "string" ? new Date(date) : date).toLocaleString(
        "en-US",
        { timeZone: tzString }
      )
    );
  }

  return (
    <>
      {!isTeamBallotVoteEnabled && isTeamBallotVoteEnabled !== "" ? (
        <>
          <Grid container p={1}>
            <Grid item lg={12}>
              <EmptyUI
                heading="NBA Draft Combine Ballot"
                subHeading={
                  AppConstatnts.BALLOT_VOTE.BALLOT_VOTE_EVENT_HEADING_MSG
                }
                textColor="#000000"
                icon={<ContactSupportIcon />}
                iconStyles={{
                  fontSize: "10rem",
                  color: "#8c9dc4",
                }}
                styles={{
                  minHeight: "500px",
                }}
                actionLabel="Home"
                onActionClick={handleNavigateToHome}
                actionIcon={<HomeIcon />}
              />
            </Grid>
          </Grid>
        </>
      ) : isTeamBallotVoteEnabled ? (
        <>
          <Grid container p={1} className={classes.root}>
            <Grid
              item
              lg={3}
              md={3.5}
              sm={12}
              xs={12}
              className={classes.borderRight}
            >
              <Box pr={1.25}>
                <Typography
                  component="div"
                  align="center"
                  className={`${classes.statBoardHeaderTitle} stat-board-header-title`}
                  // className="stat-board-header-title"
                >
                  NBA Draft Combine Ballot
                </Typography>
                <Typography
                  display="flex"
                  component="span"
                  justifyContent="center"
                  variant="subtitle2"
                  sx={{ color: "#c8102e" }}
                  className="timer"
                  // sx={{ color: "#D4485F" }}
                >
                  <Box
                    columnGap={1}
                    display="flex"
                    component="span"
                    justifyContent="center"
                    sx={{ lineHeight: 1.8 }}
                  >
                    {votingDisabled ? (
                      voteMessage
                    ) : (
                      <>
                        <SnoozeIcon />
                        Time Remaining
                      </>
                    )}
                  </Box>
                </Typography>
                {votingDisabled ? (
                  ""
                ) : (
                  <Typography
                    pl={2}
                    display="flex"
                    columnGap={1}
                    justifyContent="center"
                    component="div"
                    variant="subtitle2"
                    className="timer"
                  >
                    <div>
                      <span className="days">{padStart(days)}</span>
                      <div className="small-text">Days</div>
                    </div>
                    <div>
                      <span className="hours">{padStart(hours)}</span>
                      <div className="small-text">Hours</div>
                    </div>
                    <div>
                      <span className="minutes">{padStart(minutes)}</span>
                      <div className="small-text">Minutes</div>
                    </div>
                  </Typography>
                )}
              </Box>
            </Grid>

            <Grid item lg={9} md={8.3} sm={12} xs={12}>
              <Grid container className={classes.shootingPoints}>
                <Grid item lg={1.7} md={1.7} sm={1.8} xs={3.5}>
                  <Typography
                    component="div"
                    className={`${classes.totalVotesHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "total-votes-header-title-roboto"
                        : "total-votes-header-title-nba"
                    }`}
                  >
                    {`${padStart(totalVotesSelected)}/${padStart(
                      totalVotes.current
                    )}`}
                  </Typography>
                  <Typography
                    align="left"
                    component="span"
                    variant={window.innerWidth <= 414 ? "caption" : "subtitle2"}
                    sx={{ color: "rgb(118, 118, 118)" }}
                  >
                    Total Votes <br />
                    Selected
                  </Typography>
                </Grid>
                <Grid item lg={1.7} md={1.6} sm={1.5} xs={1.5}>
                  <Typography
                    pt={2}
                    component="div"
                    className={`${classes.positionsHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "positions-header-title-roboto"
                        : "positions-header-title-nba"
                    }`}
                  >
                    {`${padStart(positionStats[0])}`}
                  </Typography>
                  <Typography
                    align="left"
                    component="span"
                    variant={window.innerWidth <= 414 ? "caption" : "subtitle2"}
                    sx={{ color: "rgb(118, 118, 118)" }}
                  >
                    {positionsFontStyle[0]}
                  </Typography>
                </Grid>
                <Grid item lg={1.7} md={1.9} sm={1.9} xs={1.5}>
                  <Typography
                    pt={2}
                    component="div"
                    className={`${classes.positionsHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "positions-header-title-roboto"
                        : "positions-header-title-nba"
                    }`}
                  >
                    {`${padStart(positionStats[1])}`}
                  </Typography>
                  <Typography
                    align="left"
                    component="span"
                    variant={window.innerWidth <= 414 ? "caption" : "subtitle2"}
                    sx={{ color: "rgb(118, 118, 118)" }}
                  >
                    {positionsFontStyle[1]}
                  </Typography>
                </Grid>
                <Grid item lg={1.7} md={1.9} sm={1.8} xs={1.5}>
                  <Typography
                    pt={2}
                    component="div"
                    className={`${classes.positionsHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "positions-header-title-roboto"
                        : "positions-header-title-nba"
                    }`}
                  >
                    {`${padStart(positionStats[2])}`}
                  </Typography>
                  <Typography
                    align="left"
                    component="span"
                    variant={window.innerWidth <= 414 ? "caption" : "subtitle2"}
                    sx={{ color: "rgb(118, 118, 118)" }}
                  >
                    {positionsFontStyle[2]}
                  </Typography>
                </Grid>
                <Grid item lg={1.7} md={1.9} sm={1.8} xs={1.5}>
                  <Typography
                    pt={2}
                    component="div"
                    className={`${classes.positionsHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "positions-header-title-roboto"
                        : "positions-header-title-nba"
                    }`}
                  >
                    {`${padStart(positionStats[3])}`}
                  </Typography>
                  <Typography
                    align="left"
                    component="span"
                    variant={window.innerWidth <= 414 ? "caption" : "subtitle2"}
                    sx={{ color: "rgb(118, 118, 118)" }}
                  >
                    {positionsFontStyle[3]}
                  </Typography>
                </Grid>
                <Grid item lg={1.7} md={1.3} sm={1.5} xs={1.5}>
                  <Typography
                    pt={2}
                    component="div"
                    className={`${classes.positionsHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "positions-header-title-roboto"
                        : "positions-header-title-nba"
                    }`}
                  >
                    {`${padStart(positionStats[4])}`}
                  </Typography>
                  <Typography
                    align="left"
                    component="span"
                    variant={window.innerWidth <= 414 ? "caption" : "subtitle2"}
                    sx={{ color: "rgb(118, 118, 118)" }}
                  >
                    {positionsFontStyle[4]}
                  </Typography>
                </Grid>
                <Grid item lg={1.7} md={1.5} sm={1.7} xs={6}>
                  <Typography
                    component="div"
                    className={`${classes.totalVotesHeaderTitle} ${
                      window.innerWidth <= 414
                        ? "total-votes-header-title-roboto"
                        : "total-votes-header-title-nba"
                    }`}
                    sx={{ color: "#c8102e !important" }}
                  >
                    {`${padStart(totalVotesSubmitted)}/${padStart(
                      totalVotes.current
                    )}`}
                  </Typography>
                  {window.innerWidth <= 414 ? (
                    <Typography
                      align="left"
                      component="span"
                      variant={"caption"}
                      sx={{ color: "rgb(118, 118, 118)" }}
                    >
                      Total Votes Submitted
                    </Typography>
                  ) : (
                    <Typography
                      align="left"
                      component="span"
                      variant={"subtitle2"}
                      sx={{ color: "rgb(118, 118, 118)" }}
                    >
                      Total Votes <br />
                      Submitted
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Alert severity="info" sx={{ margin: "15px 15px 0" }}>
            {window.innerWidth <= 414 ? (
              <Typography sx={{ fontSize: "0.7rem !important" }}>
                Note: "Final Submit" enables after reaching max vote count
                defined. Once complete, please review your votes and submit.
              </Typography>
            ) : (
              `Note: "Final Submit" enables after reaching max vote count defined.
            Once complete, please review your votes and submit.`
            )}
          </Alert>
          <Paper elevation={2} className={classes.gridContainer}>
            <Box>
              <Grid container>
                <Grid item lg={5} md={6} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      label="Search Player or College Name"
                      value={playerNameSearchText || ""}
                      onChange={(e) =>
                        searchPlayerOrCollegeName(e.target.value)
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {playerNameSearchText !== "" && (
                              <IconButton
                                aria-label="Clear Search"
                                onClick={(e) => searchPlayerOrCollegeName("")}
                                edge="end"
                              >
                                <ClearIcon color="secondary" />
                              </IconButton>
                            )}
                            <IconButton aria-label="Search" edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </Grid>
                {/* <Grid lg={3} md={1}></Grid> */}
                <Grid
                  item
                  lg={7}
                  md={6}
                  sm={6}
                  xs={12}
                  container
                  justifyContent="flex-end"
                  className={classes.buttonArea}
                >
                  <Button
                    className={classes.actionButton}
                    variant="contained"
                    onClick={() => handleSubmitAction("draft")}
                    disabled={votingDisabled}
                  >
                    Save as Draft
                  </Button>
                  <Button
                    className={classes.actionButton}
                    disabled={
                      votingDisabled ||
                      (totalVotesSelected === totalVotes.current ? false : true)
                    }
                    variant="contained"
                    onClick={() => {
                      handleSubmitAction("final");
                    }}
                  >
                    Final Submit
                  </Button>
                </Grid>
              </Grid>
              <Snackbar
                open={alert}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                autoHideDuration={3000}
                onClose={handleAlertClose}
              >
                <Alert
                  onClose={handleAlertClose}
                  severity={alertType}
                  sx={{ width: "100%" }}
                >
                  {alertMessage}
                </Alert>
              </Snackbar>
              <ConfirmationDialog
                open={open}
                dialogTitle={"Please review your votes before final submission"}
                messageBody={
                  <Box
                    mt={2}
                    sx={{
                      overflow: "auto",
                      overflowY: "hidden",
                      height: "100%",
                      width: "100%",
                    }}
                    className="player-list-box"
                  >
                    <Box
                      className="row-header"
                      sx={{
                        display: "flex",
                        // gridTemplateColumns: "300px 400px 200px 400px",
                        width: windowInnerWidth,
                      }}
                    >
                      <Box
                        sx={{
                          maxWidth: `${columnMaxWidth[0]}`,
                          flex: `0 0 300px`,
                        }}
                      >
                        <Typography
                          noWrap
                          pl={3}
                          sx={{
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            fontWeight: "500",
                          }}
                        >
                          Player
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          maxWidth: `${columnMaxWidth[1]}`,
                          flex: `0 0 400px`,
                        }}
                      >
                        <Typography
                          noWrap
                          pl={3}
                          sx={{
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            fontWeight: "500",
                          }}
                        >
                          College/Club
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          maxWidth: `${columnMaxWidth[2]}`,
                          flex: `0 0 400px`,
                        }}
                      >
                        <Typography
                          noWrap
                          sx={{
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            fontWeight: "500",
                          }}
                        >
                          Position
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        height: "400px",
                        width: windowInnerWidth,
                      }}
                    >
                      <AutoSizer>
                        {({ height, width }) => (
                          <>
                            <List
                              height={height}
                              width={width}
                              itemSize={50}
                              itemCount={confirmFinalVotedPlayers.length}
                            >
                              {VotedPlayersFinalConfirmationRow}
                            </List>
                          </>
                        )}
                      </AutoSizer>
                    </Box>
                  </Box>
                }
                onClose={handleConfirmationBoxClose}
                onSubmit={() => {
                  submitBallotVoteList("final");
                }}
                teamBallotDashboard={true}
              />
            </Box>
            <Box
              mt={2}
              sx={{
                height: votingDisabled
                  ? "calc(100vh - 284px)"
                  : "calc(100vh - 324px)",
                // height: "100%",
                overflow: "auto",
                overflowY: "hidden",
              }}
              className="player-list-box"
            >
              <Box
                className="row-header"
                sx={{
                  display: "flex",
                  // gridTemplateColumns: "300px 400px 200px 400px",
                  width: windowInnerWidth,
                }}
              >
                <Box
                  sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 300px` }}
                >
                  <Typography
                    noWrap
                    pl={3}
                    sx={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    Player
                  </Typography>
                </Box>
                <Box
                  sx={{ maxWidth: `${columnMaxWidth[1]}`, flex: `2 0 400px` }}
                >
                  <Typography
                    noWrap
                    pl={3}
                    sx={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    College/Club
                  </Typography>
                </Box>
                <Box
                  sx={{
                    maxWidth: `${columnMaxWidth[2]}`,
                    flex: `1 0 200px`,
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "5px",
                  }}
                >
                  <Typography
                    sx={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    Vote
                  </Typography>
                  {voteSort ? (
                    <ArrowDropUpIcon
                      sx={{ marginTop: "10px", cursor: "pointer" }}
                      onClick={(e) => toggleVoteSort(0)}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      sx={{ marginTop: "10px", cursor: "pointer" }}
                      onClick={(e) => toggleVoteSort(1)}
                    />
                  )}
                </Box>
                <Box
                  sx={{ maxWidth: `${columnMaxWidth[3]}`, flex: `2 0 400px` }}
                >
                  <Typography
                    noWrap
                    sx={{
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      fontWeight: "500",
                    }}
                  >
                    Position
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  /*height: "calc(100vh - 475px)"*/ height: "100%",
                  width: windowInnerWidth,
                }}
              >
                <AutoSizer>
                  {({ height, width }) => (
                    <>
                      <List
                        height={height - 50}
                        width={width}
                        itemSize={50}
                        itemCount={playerData.length}
                      >
                        {Row}
                      </List>
                    </>
                  )}
                </AutoSizer>
              </Box>
            </Box>
            <Modal
              open={openModal}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Box display="flex" justifyContent="space-between">
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    color="secondary"
                  >
                    Please select position(s) for the below selected player(s)
                  </Typography>
                  <IconButton
                    size="small"
                    aria-label="Close"
                    onClick={handleClose}
                    title="Close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box
                  mt={2}
                  sx={{
                    overflow: "hidden",
                    overflowY: "hidden",
                    width: "65vw",
                    height: "94%",
                  }}
                  className="playerlist"
                >
                  <Box
                    className="row-header"
                    sx={{
                      display: "flex",
                      // gridTemplateColumns: "300px 400px 200px 400px",
                      width: "65vw",
                    }}
                  >
                    <Box
                      sx={{
                        maxWidth: `${columnMaxWidth[0]}`,
                        flex: `0 0 300px`,
                      }}
                    >
                      <Typography
                        noWrap
                        pl={3}
                        sx={{
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          fontWeight: "500",
                        }}
                      >
                        Player
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        maxWidth: `${columnMaxWidth[1]}`,
                        flex: `0 0 300px`,
                      }}
                    >
                      <Typography
                        noWrap
                        pl={3}
                        sx={{
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          fontWeight: "500",
                        }}
                      >
                        College/Club
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ height: "94%", width: "65vw" }}>
                    <AutoSizer>
                      {({ height, width }) => (
                        <>
                          <List
                            height={height}
                            width={width}
                            itemSize={50}
                            itemCount={playersVotedWithoutPositions.length}
                          >
                            {PlayersVotedWithoutPositionsRow}
                          </List>
                        </>
                      )}
                    </AutoSizer>
                  </Box>
                </Box>
              </Box>
            </Modal>
          </Paper>
        </>
      ) : (
        <Box className={classes.loadingOverlay}>
          <CircularProgress />
        </Box>
      )}
    </>
  );
}
